export const parseBoundDate = (bound) => {
  if (!bound || bound === '') return null;
  if (bound instanceof Date && !Number.isNaN(bound.getTime())) {
    return bound;
  }
  return null;
};

const startOfDay = (date) => {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
};

const endOfMonth = (year, monthIndex) =>
  new Date(year, monthIndex + 1, 0, 23, 59, 59, 999);

export const isYearSelectable = (year, minDate, maxDate) => {
  const min = parseBoundDate(minDate);
  const max = parseBoundDate(maxDate);
  if (min && year < min.getFullYear()) return false;
  if (max && year > max.getFullYear()) return false;
  return true;
};

export const isMonthSelectable = (year, monthIndex, minDate, maxDate) => {
  const min = parseBoundDate(minDate);
  const max = parseBoundDate(maxDate);
  const monthStart = startOfDay(new Date(year, monthIndex, 1));
  const monthEnd = endOfMonth(year, monthIndex);

  if (min && monthEnd < startOfDay(min)) return false;
  if (max && monthStart > startOfDay(max)) return false;
  return true;
};

export const getYearBounds = (minDate, maxDate) => {
  const min = parseBoundDate(minDate);
  const max = parseBoundDate(maxDate);
  const currentYear = new Date().getFullYear();

  return {
    minYear: min ? min.getFullYear() : currentYear - 100,
    maxYear: max ? max.getFullYear() : currentYear + 30,
  };
};

export const clampYearRangeStart = (start, minDate, maxDate, pageSize = 12) => {
  const { minYear, maxYear } = getYearBounds(minDate, maxDate);
  let nextStart = start;
  const maxStart = Math.max(minYear, maxYear - pageSize + 1);

  if (nextStart > maxStart) {
    nextStart = maxStart;
  }
  if (nextStart < minYear) {
    nextStart = minYear;
  }

  return nextStart;
};

export const canNavigateYearPage = (yearRangeStart, direction, minDate, maxDate, pageSize = 12) => {
  const { minYear, maxYear } = getYearBounds(minDate, maxDate);
  const pageEnd = yearRangeStart + pageSize - 1;

  if (direction < 0) {
    return yearRangeStart > minYear;
  }

  return pageEnd < maxYear;
};
